module.exports = __webpack_public_path__ + "static/media/food12345.63bb3257.jpg";